import { isEnabled } from '@utils/feature';
import { render } from 'base/wrapped-render';
import { GlobalEmploymentInPageMessage } from '.';

// Injects the EOR marketing message into the People tab (Directory or Org Chart).
// If/when this component is migrated to PO controls, use:
//   import { GlobalEmploymentInPageMessage } from '@bhr-libraries/controls'
export function injectPeopleTabGlobalEmploymentMessage(pageHeaderSelector: string): void {
    // Feature flag check
    if (!isEnabled('EOR_REMOTE_ONBOARDING_INTEGRATION')) {
        return;
    }

    const headerContainer = document.querySelector<HTMLElement>(pageHeaderSelector);
    const optionalContent = document.querySelector<HTMLElement>(`${pageHeaderSelector} .PageHeader__optionalContentWrap`);
    const newEmployeeButton = document.querySelector<HTMLElement>('[data-bi-id="people-add-new-employee-button"]');

    // Abort if required containers are missing
    if (!headerContainer || !optionalContent) {
        return;
    }

    const MESSAGE_CONTAINER_ID = 'js-globalEmploymentInPageMessaging-peopleTab';

    // Avoid injecting duplicate containers
    if (document.getElementById(MESSAGE_CONTAINER_ID)) {
        return;
    }

    // Create and insert container
    const messageContainer = document.createElement('div');
    messageContainer.id = MESSAGE_CONTAINER_ID;
    headerContainer.insertBefore(messageContainer, optionalContent);

    // Apply inline styles
    headerContainer.style.height = 'unset';

    const isOrgChart = pageHeaderSelector === '#orgChartHead';
    if (newEmployeeButton && isOrgChart) {
        newEmployeeButton.style.marginBottom = '24px';
    }

    render(
        <GlobalEmploymentInPageMessage margin="20px 0 16px" widgetLocation="people" />,
        messageContainer
    );
}
